import React from "react";
import { Trans } from "@lingui/macro";
import * as styles from "./PriceFromBox.module.scss";
import { useLanguage } from "src/utils/localization/languages/I18nContext";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { formatCurrency } from "src/utils/localization/formatCurrency";
import classNames from "classnames";
import { CruisePriceFrom } from "types/api/suite_price.d";

export interface PriceFromBoxProps {
  className?: string;
  promoClassName?: string;
  price?: CruisePriceFrom;
}

const PriceFromBox: React.FC<PriceFromBoxProps> = ({
  price,
  className = undefined,
  promoClassName = undefined,
  children
}) => {
  const language = useLanguage();
  const geolocation = useGeolocation();
  const currency = geolocation.defaultCurrency;
  let formattedPrice;
  switch (price?.type) {
    case "price":
      formattedPrice = formatCurrency(price.amount, currency, language.code);
      break;
    case "waitlist":
      formattedPrice = <Trans id="waitlist (price)">WAITLIST</Trans>;
      break;
  }

  return (
    <div className={classNames([styles.price, className])}>
      <div>
        <Trans id="price-from">FROM</Trans>: <em>{formattedPrice}</em>
      </div>
      {React.Children.count(children) > 0 && (
        <div className={classNames([styles.promo, promoClassName])}>
          {children}
        </div>
      )}
    </div>
  );
};

export default PriceFromBox;
